import { Door, Key, Permission } from "./types";

interface Dane {
  [klucz: string]: number[];
}

function czySaTakieSameTablice(dane: Dane): boolean {
  const posortowaneDane: Dane = {};
  for (const klucz in dane) {
    const posortowanaTablica = dane[klucz].slice().sort();
    posortowaneDane[klucz] = posortowanaTablica;
  }
  for (const klucz1 in posortowaneDane) {
    for (const klucz2 in posortowaneDane) {
      if (
        klucz1 !== klucz2 &&
        posortowaneDane[klucz1].toString() ===
          posortowaneDane[klucz2].toString()
      ) {
        return true;
      }
    }
  }
  return false;
}

function checkDuplicatePermissions(
  keys: Key[],
  permission: Permission[]
): { duplicatePermissions: boolean; keyWithoutPerm: boolean } {
  type UniqueKeyArrayObject = Record<number, number[]>;
  const myObject: UniqueKeyArrayObject = {};
  let keyWithoutPerm = false;

  function addToKey(key: number, value: number): void {
    if (myObject[key]) {
      myObject[key].push(value);
    } else {
      myObject[key] = [value];
    }
  }
  permission.forEach((record) => {
    addToKey(record.idKey, record.idDoor);
  });

  keys.forEach((key) => {
    if (myObject[key.id] === undefined) keyWithoutPerm = true;
  });

  const duplicatePermissions: boolean = czySaTakieSameTablice(myObject);

  return { duplicatePermissions, keyWithoutPerm };
}

export function validatePermissions(
  doors: Door[],
  keys: Key[],
  permission: Permission[]
) {
  const { duplicatePermissions, keyWithoutPerm } = checkDuplicatePermissions(
    keys,
    permission
  );

  const locksWithoutKey = doors.some(
    (door) => !permission.some((perm) => perm.idDoor === door.id)
  );

  return { duplicatePermissions, locksWithoutKey, keyWithoutPerm };
}
